// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__5toer","ant-page-header-heading-title":"styles_ant-page-header-heading-title__4ln-z","table":"styles_table__f3hOA"};